import React, { Component } from 'react';
import Menu from './menu';
import Stores from './stores';
import Social from './social';
import globalizacao from '../escolha/globalizacao';

class Footer extends Component {

    state = {
        lang: window.localStorage["site-lang"] || globalizacao.getLinguaDoUsuario()
    }

    changeLang(e) {
        window.localStorage["site-lang"] = e.target.value;
        this.setState({
            lang: e.target.value
        });
        window.location.href = "/";
    }

    render() {
        return (
            <footer className="footer">
                <div className="limite footer-container">
                    <div className="clearfix">


                        <div className="container-menu">
                            <Menu />
                        </div>

                    </div>
                    <Stores />
                    <Social />
                </div>
                <div className="txt-rodape ">


                    <div className="limite">
                        <i style={{
                            verticalAlign: "text-top",
                            fontSize: "12px"
                        }} className="material-icons">mail</i> contato@escolhatecnologia.com.br{" "}|{" "}
                        <i style={{
                            verticalAlign: "text-top",
                            fontSize: "12px"
                        }} className="material-icons">translate</i> {globalizacao.msg("idioma")}:
                        <select value={this.state.lang} onChange={this.changeLang.bind(this)}>
                            <option value="pt-BR">Português</option>
                            <option value="en-US">English</option>
                            <option value="es">Español</option>
                        </select>
                        <div>
                            <i style={{
                                verticalAlign: "text-top",
                                fontSize: "12px"
                            }} className="material-icons">copyright</i>  2022 {globalizacao.msg("direitos")}  | Escolha Tecnologia
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/js/components/footer.js